import style from './InfoFeedbackScreen.css';
import AppBar from '../AppBar/AppBar';
import Title from '../Typography/Title';
import BodyText from '../Typography/BodyText';
import Button from '../Button/Button';

export default function InfoFeedbackScreen({
  className = '',
  onBackClick = null,
  onCloseClick = null,
  closeRef,
  image,
  title,
  subtitle,
  ctaAction,
  ctaText,
}) {
  return (
    <div className={`${className} ${style.main}`}>
      <AppBar
        onBackClick={onBackClick}
        onCloseClick={onCloseClick}
        closeRef={closeRef}
        className="fixed-bar"
      />

      <div className={style.content}>
        <div className={style['feedback-image']}>
          <img src={image} width={160} height={160} />
        </div>

        <div className={style['feedback-text-wrapper']}>
          <div className={style['feedback-title']}>
            <Title text={title} className="text-center" />
          </div>

          <div className={style['feedback-subtitle']}>
            <BodyText
              text={subtitle}
              className={`text-center ${style['feedback-subtitle-text']}`}
            />
          </div>
        </div>
      </div>
      <div className="fixed-cta">
        <Button onClick={ctaAction}>{ctaText}</Button>
      </div>
    </div>
  );
}
